/* eslint-disable react/prop-types */
import React from 'react';
import LabelInput from 'components/custom/forms/LabelInput';
import { Col, Row } from 'react-bootstrap';
import LabelDateSelector from 'components/custom/forms/LabelDateSelector';
import LabelSelector from 'components/custom/forms/LabelSelector';
import useModalManage from 'hooks/custom/useModalManage';
import { useAlert } from 'providers/AlertModalProvider';
import { useFormik } from 'formik';
import CreateModal from 'components/custom/modal/CreateModal';
import * as Yup from 'yup';
import postData from 'services/postData';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import { formatDate } from 'services/utils';

const leaveType = [
  { label: 'Casual Leave', value: 'Casual Leave' },
  { label: 'Sick Leave', value: 'Sick Leave' },
  { label: 'Early Leave', value: 'Early Leave' },
  { label: 'Half Day', value: 'Half Day' },
  { label: 'Emergency Leave', value: 'Emergency Leave' }
];

const CreateLeavePage = ({ show, handleClose, handleRefresh, userType }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const [empList] = useFetchData(
    userType == 'Driver'
      ? apiEndpoints.driver.getAll
      : apiEndpoints.employee.getAll
  );
  const { showAlert } = useAlert();

  const handleCreateLeave = async values => {
    setModalLoading(true, `Creating ${userType} Leave`);
    const payload = {
      ...values,
      leave_from: formatDate(values.leave_from, 'YYYY-MM-DD hh:mm:ss'),
      leave_to: formatDate(values.leave_to, 'YYYY-MM-DD hh:mm:ss')
    };
    if (payload.userType === 'Driver') {
      payload['driver_id'] = payload.user_id;
    }
    // Assuming postData is a function that handles the API call
    const request = await postData(payload, apiEndpoints.leave.create);
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to create the ${userType} Leave.`
      });
      handleRefresh();
      handleClose();
    } else {
      setModalLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to create the ${userType} Leave.`
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      user_id: '',
      leave_type: '',
      leave_from: '',
      leave_to: '',
      // admin_comment: '',
      // employee_comment: '',
      ...(userType === 'Driver'
        ? { admin_comment: '' }
        : { employee_comment: '' }),
      user_type: userType
    },
    validationSchema: Yup.object({
      user_id: Yup.number(),
      leave_type: Yup.string().required('Leave Type is required'),
      leave_from: Yup.mixed().required('Leave from is required'),
      leave_to: Yup.mixed().required('Leave to is required'),

      ...(userType === 'Driver'
        ? { admin_comment: Yup.string().required('Reason is required') }
        : { employee_comment: Yup.string().required('Reason is required') })
    }),
    onSubmit: values => {
      handleCreateLeave(values);
    }
  });

  return (
    <CreateModal
      show={show}
      loading={modalLoading}
      loadingText={modalMessage}
      handleClose={handleClose}
      heading={`Create ${userType} Leave`}
      handleSubmit={formik.handleSubmit}
    >
      <Row className="mb-2">
        <Col xs={12} sm={6} className="mt-2">
          <LabelSelector
            required
            errorProps={{ tooltip: false }}
            options={{
              data: empList,
              valueKey: userType === 'Driver' ? 'driver_id' : 'employee_id',
              labelKey: 'first_name',
              descKey:
                userType === 'Driver' ? 'driver_mobile' : 'employee_mobile'
            }}
            label={`Select ${userType}`}
            controlId={`${userType === 'Driver' ? 'driver_id' : 'employee_id'}`}
            formik={formik}
            placeholder={`Select ${userType}`}
          />
        </Col>
        <Col xs={12} sm={6} className="mt-2">
          <LabelSelector
            required
            errorProps={{ tooltip: false }}
            options={{
              data: leaveType,
              valueKey: 'value',
              labelKey: 'label'
            }}
            label="Leave Type"
            controlId="leave_type"
            formik={formik}
            placeholder={'Select Leave Type'}
          />
        </Col>
        <Col className="mt-2" sm={6}>
          <LabelDateSelector
            errorProps={{ tooltip: false }}
            controlId="leave_from"
            label="Leave From"
            formik={formik}
            dateOptions={{
              // datePostFormate: 'DD-MM-YYYY hh:mm:ss',
              datePostFormate: 'YYYY-MM-DD hh:mm:ss',
              enableTime: 'true',
              dateFormat: 'Y-m-d H:i:S',
              altFormat: 'd-m-Y h:i K',
              maxDate: '',
              static: true
            }}
            required
          />
        </Col>
        <Col className="mt-2" sm={6}>
          <LabelDateSelector
            errorProps={{ tooltip: false }}
            controlId="leave_to"
            label="Leave To"
            formik={formik}
            dateOptions={{
              datePostFormate: 'YYYY-MM-DD hh:mm:ss',
              enableTime: 'true',
              dateFormat: 'Y-m-d H:i:S',
              altFormat: 'd-m-Y h:i K',
              maxDate: '',
              static: true
            }}
            required
          />
        </Col>
        <Col xs={12} className="mt-2">
          <LabelInput
            errorProps={{ tooltip: false }}
            // controlId="admin_comment"
            // controlId={`${userType === 'employee_comment' ? 'driver_id' : 'admin_comment'}`}
            controlId={`${userType === 'Driver' ? 'admin_comment' : 'employee_comment'}`}
            label="Reason"
            inputProps={{ as: 'textarea' }}
            formik={formik}
            required
          />
        </Col>
      </Row>
    </CreateModal>
  );
};

export default CreateLeavePage;
